export { default } from "./ModalAddCredit-component";
